module.exports = "<p>\n  release-manager works!\n</p>\n"